module.exports = __webpack_public_path__ + "static/media/kemdikbud.bf89001f.png";